import { Card, CardContent } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import Input from 'components/forms/Input'
import Textarea from 'components/forms/Textarea'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoCasingDeclaration from 'survey/dto/DtoCasingDeclaration'
import { getDate } from 'utils/DateUtil'
import { hasValue } from 'utils/NumberUtil'
import { getSandreLabel } from 'utils/StringUtil'

const CounterCard = ({
    title,
    counter,
    actions,
}) => {
    const {
        variousMaterielTypes,
        sandreCodes,
    } = useSelector(store => ({
        variousMaterielTypes: store.VariousMaterielReducer.variousMaterielTypes,
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)

    const counterType = variousMaterielTypes.find((t) => t.materielType === counter.materielType && t.category === 2) || {}

    return (
        <Card
            sx={{
                border: '1px solid',
                borderColor: 'primary.main',
                borderRadius: 2,
            }}
        >
            <CardTitle title={title} color={'primary'} actions={actions} />
            <CardContent>
                <Input
                    title={i18n.name}
                    value={counter.name}
                    readMode
                />
                <Input
                    title={i18n.type}
                    value={counterType.name}
                    readMode
                />
                <Input
                    title={i18n.brand}
                    value={counter.brand}
                    readMode
                />
                <Input
                    title={i18n.serialNumber}
                    value={counter.serialNumber}
                    readMode
                />
                <Input
                    title={i18n.readingCoefficient}
                    value={counter.readingCoefficient}
                    readMode
                />
                <Input
                    title={i18n.mobility}
                    value={getSandreLabel(sandreCodes, 'MAT.MOBILITE', counter.mobilityCode)}
                    readMode
                />
                <Input
                    title={i18n.installationDate}
                    value={getDate(counter.installationDate)}
                    readMode
                />
                <Input
                    title={i18n.revisionDate}
                    value={getDate(counter.revisionDate)}
                    readMode
                />
                <Input
                    title={i18n.shared}
                    value={counter.isShared ? i18n.yes : i18n.no}
                    readMode
                />
                <Input
                    title={i18n.forRent}
                    value={counter.rent ? i18n.yes : i18n.no}
                    readMode
                />
                <Input
                    title={i18n.assignmentRate}
                    value={hasValue(counter.assignmentRate) ? `${counter.assignmentRate} %` : ''}
                    readMode
                />
                <Textarea
                    title={i18n.comment}
                    value={counter.comment}
                    readMode
                />
            </CardContent>
        </Card>
    )
}

CounterCard.propTypes = {
    title: PropTypes.string.isRequired,
    counter: PropTypes.instanceOf(DtoCasingDeclaration).isRequired,
    actions: PropTypes.arrayOf(PropTypes.shape({
        onClick: PropTypes.func,
        iconName: PropTypes.string,
    })),
}

export default CounterCard
